import styled from 'styled-components';
import Button from 'core/common/components/ButtonDeprecated';
import Checkbox from 'core/common/components/Checkbox';

export const PageWrapper = styled.div`
  max-width: 446px;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 24px;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    padding-bottom: 160px;
  }
`;

export const MobileImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 36px;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    display: none;
  }
`;

export const DesktopImage = styled.div`
  display: none;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 24px;
  }
`;

export const MainContentWrapper = styled.div`
  width: 100%;
  margin-bottom: 52px;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    margin-bottom: 72px;
  }
`;

export const CompatibilityHeader = styled.h1`
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 700;
  line-height: 134%;
  color: ${({ theme }) => theme.colors.typography900};

  @media ${({ theme }) => theme.breakpoints.desktop} {
    margin-bottom: 12px;
    font-size: 32px;
    line-height: 150%;
  }
`;

export const DoNotMissText = styled.p`
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 171%;
  color: ${({ theme }) => theme.colors.typography900};

  @media ${({ theme }) => theme.breakpoints.desktop} {
    margin-bottom: 28px;
    font-size: 16px;
    line-height: 150%;
  }
`;

export const GuaranteeWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 36px;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    margin-bottom: 48px;
  }
`;

export const GuaranteeText = styled.span`
  margin-left: 1px;
  font-size: 12px;
  line-height: 150%;
  color: ${({ theme }) => theme.colors.typography900};

  @media ${({ theme }) => theme.breakpoints.desktop} {
    margin-left: 4px;
    font-size: 14px;
  }
`;

export type PhoneInputWrapperProps = {
  error?: unknown;
};

export const PhoneInputWrapper = styled.div<PhoneInputWrapperProps>`
  position: relative;
  display: flex;
  width: 100%;
  height: 44px;
  margin-bottom: 8px;

  .PhoneInput {
    display: flex;
    flex-grow: 1;
  }

  input {
    border: ${(props) => (props.error ? `1.5px solid ${props.theme.colors.error}` : 'none')};
    outline: none;
  }

  @media ${({ theme }) => theme.breakpoints.desktop} {
    margin-bottom: 12px;
  }
`;

export const PhoneInputError = styled.div`
  position: absolute;
  top: -18px;
  left: 0;
  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.colors.error};
`;

export const PhoneInput = styled.input`
  flex-grow: 1;
  height: 100%;
  padding: 8px 12px;
  border-radius: 32px;
  font-size: 16px;
  line-height: 171%;
  color: ${({ theme }) => theme.colors.typography900};
  background-color: rgba(224, 224, 224, 0.4);

  &::placeholder {
    line-height: 171%;
    color: ${({ theme }) => theme.colors.typography500};
  }

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.typography500};
    background-color: ${({ theme }) => theme.colors.typography200};
  }
`;

export const ConfirmationLabelWrapper = styled.div``;

export const ConfirmationCheckbox = styled(Checkbox)`
  align-items: center;
  font-size: 12px;
  line-height: 130%;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    font-size: 14px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const GetPersonalizedUpdatesButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  margin-bottom: 14px;
  font-size: 18px;
  font-weight: 600;
  line-height: 134%;
  background: linear-gradient(
    165.54deg,
    #141333 -33.39%,
    #202261 15.89%,
    #543c97 55.84%,
    #6939a2 74.96%
  );

  @media ${({ theme }) => theme.breakpoints.desktop} {
    height: 56px;
  }
`;

export const NoUpdatesNeededButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.colors.typography500};
`;
